import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../dynamicCopy/embed/DynamicCopyEmbed.vue.js';
import { getObjectValueFromPath } from '../../../../../dynamicCopy/general/helpers.js';
import { getStore } from '../../../../../../store/helpers/initStore.js';

var script = defineComponent({
    name: 'WorkflowEmbed',
    components: {
        DynamicCopyEmbed: __vue_component__,
    },
    props: {
        embedPath: {
            type: String,
            default: undefined,
        },
    },
    setup(props) {
        const embed = computed(() => {
            var _a;
            if (!props.embedPath) {
                return undefined;
            }
            const store = getStore();
            const embedValue = getObjectValueFromPath((_a = store.state.variables.variables) === null || _a === void 0 ? void 0 : _a.dynamicCopy, props.embedPath);
            return embedValue;
        });
        return {
            embed,
        };
    },
});

export { script as default };
